import { render } from "./InitialTab.vue?vue&type=template&id=46dd0f17"
import script from "./InitialTab.vue?vue&type=script&lang=js"
export * from "./InitialTab.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__